import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

export const insertNewRelicScript = (appId: string | undefined) => {
  if (!appId) {
    console.error('Missing New Relic Application ID');
    return;
  }
  // Populate using values in copy-paste JavaScript snippet.
  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: false },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },
    info: {
      accountID: '4713896',
      trustKey: '4713896',
      agentID: appId,
      licenseKey: 'NRJS-25a296302b943e8699a',
      applicationID: appId,
    },
    loader_config: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-25a296302b943e8699a',
      applicationID: appId,
      sa: 1,
    },
  };
  // The agent loader code executes immediately on instantiation.
  new BrowserAgent(options);
};
